import { Button } from "@components/atoms/Button"
import { cn, tv } from "@utils/tw"
import { useEffect, useState } from "react"

type shareProps = {
  facebook: string
  linkedin: string
  twitter: string
  email: string
}

export const Share = ({ title, end }: { title: string; end?: boolean }) => {
  const [open, setOpen] = useState<boolean>(false)
  const [copiedLink, setCopiedLink] = useState<boolean>(false)
  const [shareLinks, setShareLinks] = useState<shareProps | null>(null)

  useEffect(() => {
    if (location.href) {
      setShareLinks({
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(location.href)}`,
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURI(location.href)}`,
        twitter: `https://twitter.com/intent/tweet?url=${encodeURI(location.href)}`,
        email: `mailto:?body=${encodeURI(location.href)}&subject=${title}`,
      })
    }
  }, [location.href])

  async function copyLink() {
    await navigator.clipboard.writeText(location.href)
    setCopiedLink(true)
  }

  return (
    <div className={cn(shareContainerStyles({ open, end }))}>
      <Button color="grey" size="small" icon="SHARE" iconStyle="left" onClick={() => setOpen(!open)}>
        Share
      </Button>
      <div>
        {shareLinks && (
          <ul>
            <li>
              <Button
                color="white"
                size="tiny"
                icon="FACEBOOK"
                iconStyle="left"
                href={shareLinks.facebook}
                target="_blank"
              >
                Facebook
              </Button>
            </li>
            <li>
              <Button
                color="white"
                size="tiny"
                icon="LINKEDIN"
                iconStyle="left"
                href={shareLinks.linkedin}
                target="_blank"
              >
                LinkedIn
              </Button>
            </li>
            <li>
              <Button color="white" size="tiny" icon="X" iconStyle="left" href={shareLinks.twitter} target="_blank">
                X (formerly Twitter)
              </Button>
            </li>
            <li>
              <Button color="white" size="tiny" icon="EMAIL" iconStyle="left" href={shareLinks.email} target="_blank">
                Email
              </Button>
            </li>
            <li>
              <Button color="white" size="tiny" icon="LINK" iconStyle="left" onClick={copyLink}>
                {copiedLink ? `Link copied to clipboard` : `Copy link`}
              </Button>
            </li>
          </ul>
        )}
      </div>
    </div>
  )
}

const shareContainerStyles = tv({
  base: [
    "flex flex-col items-start relative",
    "[&>div]:my-2 [&>div]:max-h-0 [&>div]:overflow-hidden [&>div]:transition-[max-height,box-shadow] [&>div]:duration-300 [&>div]:ease-movement",
    "[&>div]:absolute [&>div]:top-full [&>div]:z-[5] [&>div]:bg-white [&>div]:rounded-[6px]",
    "[&_ul]:flex [&_ul]:flex-col [&_ul]:p-1",
    "[&_li_a]:w-full [&_li_a]:justify-start [&_li_a]:box-border [&_li_button]:w-full [&_li_button]:justify-start [&_li_button]:box-border",
  ],
  variants: {
    open: {
      true: "[&>div]:max-h-[50vh] [&>div]:shadow-[0px_6px_12px_0px_rgba(34,34,34,0.08),0px_1px_3px_0px_rgba(34,34,34,0.1)]",
    },
    end: {
      true: "[&>div]:top-auto [&>div]:bottom-full",
    },
  },
})
